import { OnboardingIntentStep } from 'src/app/shared/enums/intent.enum';
import { OnboardingPaths } from 'src/app/shared/interfaces/intent.interface';

const BLOOD_STEPS: OnboardingPaths = {
  [OnboardingIntentStep.Welcome]: { path: '/onboarding/blood/welcome' },
  [OnboardingIntentStep.Register]: { path: '/accounts/create' },
  [OnboardingIntentStep.Newsletter]: { path: '/accounts/newsletters' },
  [OnboardingIntentStep.Caution]: { path: '/accounts/caution' },
  [OnboardingIntentStep.Check]: { path: '/accounts/verify' },
  [OnboardingIntentStep.Login]: { path: '/accounts/check' },
  [OnboardingIntentStep.DownloadAfterCheck]: { path: '/onboarding/download' },
  [OnboardingIntentStep.Onboarding]: { path: '/onboarding/details' },
  [OnboardingIntentStep.DownloadAfterOnBoarding]: { path: '/onboarding/track' },
  [OnboardingIntentStep.PushNotifications]: {
    path: '/onboarding/push-notifications',
  },
  [OnboardingIntentStep.Claim]: { path: '/onboarding/blood/claim' },
  [OnboardingIntentStep.Sample]: { path: '/onboarding/blood/sample' },
  [OnboardingIntentStep.Complete]: { path: '/onboarding/blood/complete' },
  [OnboardingIntentStep.End]: { path: '/dashboard' },
};

export default BLOOD_STEPS;
